import { setTerm } from './helpers';

export const setHasPhoto = setTerm('wp');
